import {ObjectId} from "bson"
import {
    changeFieldProperty,
    setFieldVisibility,
} from "../../../../../apps/KpModule/actions"
import {reliefFundFormLabels, reliefFundFormsByUnit} from "../../staticEntities"

// Une ligne par forme d'aide proposée pour l'unité du type, en gardant les montants déjà saisis
export function buildAllocationRows(unitId, rows) {
    const rowByFormId = new Map(rows.filter(row => row.form?.id).map(row => [row.form.id, row]))
    return (reliefFundFormsByUnit[unitId] || []).map(formId => rowByFormId.get(formId) || {
        id: new ObjectId().toString(),
        form: {id: formId},
        formName: reliefFundFormLabels[formId],
        awardedAmount: 0
    })
}

export const module_ = {
    name: 'Decision',
    tKey: 'Décision dossier',
    object: 'ReliefFund',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            {path: 'applicationNumber', initiallyNotVisible: true},
            {path: 'organization', display: 'zipCodeAndName', tKey: 'beneficiary'},
            {path: 'object'},
            {path: 'needsTypes', tKey: 'needs'},
            {path: 'totalTotalAmountsInEuros', tooltip: true},
            {path: 'totalRequestedAmountsInEuros', tooltip: true},
            {path: 'fundingRateForEuros', initiallyNotVisible: true},
            {path: 'totalRequestedAmountsInKilograms', tooltip: true},
            {path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true, initiallyNotVisible: true}
        ],
        form: {
            fields: [
                {path: 'applicationNumber', editable: false},
                {path: 'organization', display: 'zipCodeAndName', tKey: 'beneficiary', editable: false},
                {path: 'object', editable: false},
                {path: 'description', tKey: 'Présentation des difficultés rencontrées', type: 'richTextEditor', editable: false},
                {
                    path: 'needs',
                    type: 'accordion',
                    newable: false,
                    viewMap: {
                        dt: [
                            { path: 'natureOfHelp', display: 'nameWithUnit', tKey: 'type'},
                            { path: 'totalAmountInEuros'},
                            { path: 'requestedAmountInEuros'},
                            //{ path: 'totalAmountInKilograms'},
                            { path: 'requestedAmountInKilograms'}
                        ],
                        form: [
                            {
                                path: 'natureOfHelp',
                                display: 'nameWithUnit',
                                tKey: 'type',
                                editable: false,
                                fieldPath: ['id', 'name', 'nameWithUnit', 'eligibleToEmergencyFund', 'facilityRelated', 'unit'],
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeField = needsField.viewMap.form.fields.find(field => field.path === 'landType')
                                        const totalAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'totalAmountInEuros')
                                        const requestedAmountInEurosField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInEuros')
                                        const requestedAmountInKilogramsField = needsField.viewMap.form.fields.find(field => field.path === 'requestedAmountInKilograms')
                                        const allocationsField = needsField.viewMap.form.fields.find(field => field.path === 'allocations')

                                        store.dispatch(setFieldVisibility(landTypeField.id, !!newValue && newValue.facilityRelated))

                                        store.dispatch(setFieldVisibility(totalAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInEurosField.id, !!newValue && newValue.unit.id === "euro"))
                                        store.dispatch(setFieldVisibility(requestedAmountInKilogramsField.id, !!newValue && newValue.unit.id === "kilogram"))

                                        if (newValue) {
                                            allocationsField.setValue(buildAllocationRows(newValue.unit.id, allocationsField.getValue() || []))
                                            store.dispatch(changeFieldProperty(`${allocationsField.id}.l_awardedAmount`, 'tKey', newValue.unit.id === 'kilogram' ? 'Accordé (kg)' : 'Accordé (€)'))
                                        }
                                    }
                                }
                            },
                            {
                                path: 'landType', tKey: "Le dossier concerne un lieu", display: 'name', required: true, editable: false, translate: true, sortList: false,
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const needsField = module.viewMap.form.fields.find(field => field.path === 'needs')
                                        const landTypeProofField = needsField.viewMap.form.fields.find(field => field.path === 'landTypeProof')
                                        store.dispatch(setFieldVisibility(landTypeProofField.id, !!newValue))
                                        store.dispatch(changeFieldProperty(landTypeProofField.id, 'tKey', `landTypeProof_${newValue?.id}`))
                                    }
                                }
                            },
                            { path: 'totalAmountInEuros', editable: false },
                            { path: 'requestedAmountInEuros', editable: false },
                            { path: 'totalAmountInKilograms', editable: false, hidden: true },
                            { path: 'requestedAmountInKilograms', editable: false },
                            {
                                path: 'allocations',
                                tKey: 'Répartition de l’aide accordée',
                                type: 'accordion',
                                newable: false,
                                removable: false,
                                editable: true,
                                fieldPath: ['id', 'form.id', 'formName', 'awardedAmount'],
                                viewMap: {
                                    dt: [
                                        {path: 'formName', tKey: 'form'},
                                        {path: 'awardedAmount', type: 'editNumber', editable: true}
                                    ]
                                }
                            },
                            { path: 'landTypeProof', placeholder: 'addFile(s)', required: true, fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', editable: false, hidden: true },
                            { path: 'supportingDocuments', placeholder: 'addFile(s)', fieldPath: ['id', 'filename', 'date', 'user.id', 'user.name'], type: 'simpleFiles', tKey: "needSupportingDocuments_submission", editable: false}
                        ]
                    }
                },
                {path: 'studyCommitteeComment', type: 'richTextEditor', editable: false},
                {path: 'decision', tKey: 'boardOfDirectorsDecision', type: 'richTextEditor'},
                {path: 'conversations', tKey: "interactionZone"},
                {path: 'submitter', fieldPath: ['id', 'firstname', 'lastname', 'mail'], hidden: true},
                {path: 'buttons', hidden: true}
            ]
        }
    },
    filters: [
        'userHasAuthorization',
        {
            path: 'statuses',
            client: true,
            object: 'ReliefFundApplicationStatus',
            type: 'tags',
            default: [{id: 'controlled'}],
            filters: [
                {
                    name: 'decisionStatuses',
                    match: object => {
                        return  ['controlled', 'accepted', 'refused', 'closed'].includes(object.id)
                    }
                }
            ],
            display: 'name',
            query: (context) => {
                const statuses =  context.data?.statuses || []
                return statuses.length ? { status: {$in: statuses.map(status => status.id)}} : {}
            }
        }
    ]
}
